import { beLinkHttp } from '@be-link/http';

import {
  ICheckAppIdUsedResp,
  IListQuickCommentContentData,
  IListQuickCommentContentRequest,
  IUserLivestreamRelationRequest,
  IWxConfigReq,
  IWxConfigResp,
} from './types';

/**
 * 上传用户直播间关系
 */
export const fetchUserLivestreamRelation = async (data: IUserLivestreamRelationRequest) => {
  return beLinkHttp.post<void>('/room/user-live-stream-relation', data);
};

/**
 * 查询直播间快捷评论文案（用于无快捷语时调整浮层布局）
 */
export const fetchListQuickCommentContent = (data: IListQuickCommentContentRequest) => {
  return beLinkHttp.post<IListQuickCommentContentData>('/room/list-quick-comment-content', data, { timeout: 15000 });
};

/**
 * 检查 AppID 是否使用
 */
export const fetchCheckAppIdUsed = (appId: string) => {
  return beLinkHttp.post<ICheckAppIdUsedResp>('/mini-program/check-app-id-used', { appId });
};

/**
 * 获取微信JS-SDK配置
 */
export const fetchWxConfig = (data: IWxConfigReq) => {
  return beLinkHttp.post<IWxConfigResp>('/js-sdk/get-js-sdk-signature', data);
};
